/**
 * @author
 * @description 试卷管理模块
 */

import {
  getExamPaperList,
  getEditExamPaper,
  getAddExamPaper,
  getExamPaperDetail,
  getDelExamPaper,
  auditPapers,
  releasePapers,
  randomQuestion,
} from "@/api/examPaper";

const state = () => ({
  // 试卷题目列表
  examPaperList: [],
  epQuestions: [],
  examPaperContents: {},
  addExamPaperQuestion: [],
  questionCategoryId: 0,
});

const getters = {
  getEpContents: (state) => {
    return state.examPaperContents;
  },
};
// 同步方法写在这里--对应commit
const mutations = {
  setExamPaperList(state, data) {
    state.examPaperList = data;
  },
  setEpQuestions(state, data) {
    state.epQuestions = data;
  },
  setEpContents(state, data) {
    state.examPaperContents = data;
  },
  setAddExamPaperQuestion(state, data) {
    state.addExamPaperQuestion = data;
  },
  setCurrQuestionCategoryId(state, data) {
    state.questionCategoryId = data;
  },
};
// 异步请求写在这里--对应dispatch
const actions = {
  // 批量审核试卷
  auditPapers({}, data) {
    return new Promise((resolve, reject) => {
      auditPapers(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 获取试卷列表
  getExamPaperList({}, data) {
    return new Promise((resolve, reject) => {
      getExamPaperList(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getEditExamPaper({}, data) {
    return new Promise((resolve, reject) => {
      getEditExamPaper(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getAddExamPaper({}, data) {
    return new Promise((resolve, reject) => {
      getAddExamPaper(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 获取试卷详情
  getExamPaperDetail({}, data) {
    return new Promise((resolve, reject) => {
      getExamPaperDetail(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 删除试卷
  getDelExamPaper({}, data) {
    return new Promise((resolve, reject) => {
      getDelExamPaper(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 发布试卷
  releasePapers({}, data) {
    return new Promise((resolve, reject) => {
      releasePapers(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 随机抽题
  randomQuestion({}, data) {
    return new Promise((resolve, reject) => {
      randomQuestion(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
